import StandardGateway from './lib/standard_gateway';

export default class EmailDomainHttpGateway extends StandardGateway {
  constructor(backend) {
    super(backend, 'v1/orgs/:orgId/email-domains/:accountId');
  }

  verify(params) {
    let url = `${this.endpoint.set(params).updateUrl}/verify`;
    return this.http
      .get(url, params)
      .then(dto => {
        this.observer.onFetchSuccess(dto, params);
        return dto;
      })
      .catch(error => {
        this.observer.onFetchError(error, params);
        throw error;
      });
  }

  getSenderNames(params) {
    let url = `${this.endpoint.set(params).updateUrl}/sender-names`;
    return this.http
      .get(url, params)
      .then(dto => {
        this.observer.onFetchSuccess(dto, params);
        return dto;
      })
      .catch(error => {
        this.observer.onFetchError(error, params);
        throw error;
      });
  }
}
